import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PublicOrderFormConfig } from "../../../../types/PublicOrderFormConfig";
import { SettingsRowProps } from "../../components/SettingsRow";

interface AppearanceTabProps {
  SettingsRow: React.ComponentType<SettingsRowProps>;
  config: PublicOrderFormConfig;
  handleConfigChange: <K extends keyof PublicOrderFormConfig>(key: K, value: PublicOrderFormConfig[K]) => void;
}

const AppearanceTab: FC<AppearanceTabProps> = ({ SettingsRow, config, handleConfigChange }) => {
  const { t } = useTranslation(["order_form"]);

  return (
    <div className="divide-y divide-border">
      <SettingsRow
        title={t("order_form:color_settings.primary_color.title")}
        description={t("order_form:color_settings.primary_color.description")}
      >
        <div className="flex items-center gap-2">
          <input
            type="color"
            value={config.primaryColor || "#7214FF"}
            onChange={(e) => handleConfigChange("primaryColor", e.target.value)}
            className="w-8 h-8 rounded border border-border-strong cursor-pointer"
          />
          <input
            type="text"
            value={config.primaryColor || ""}
            onChange={(e) => handleConfigChange("primaryColor", e.target.value)}
            placeholder="#7214FF"
            className="w-24 px-2 py-1 text-sm border border-gray-300 rounded-md focus:border-brand focus:ring-1 focus:ring-brand dark:border-gray-600 dark:bg-gray-700 dark:text-white font-mono"
          />
        </div>
      </SettingsRow>
      <SettingsRow
        title={t("order_form:color_settings.primary_color_light.title")}
        description={t("order_form:color_settings.primary_color_light.description")}
      >
        <div className="flex items-center gap-2">
          <input
            type="color"
            value={config.primaryColorLight || "#F1E8FF"}
            onChange={(e) => handleConfigChange("primaryColorLight", e.target.value)}
            className="w-8 h-8 rounded border border-border-strong cursor-pointer"
          />
          <input
            type="text"
            value={config.primaryColorLight || ""}
            onChange={(e) => handleConfigChange("primaryColorLight", e.target.value)}
            placeholder="#F1E8FF"
            className="w-24 px-2 py-1 text-sm border border-gray-300 rounded-md focus:border-brand focus:ring-1 focus:ring-brand dark:border-gray-600 dark:bg-gray-700 dark:text-white font-mono"
          />
        </div>
      </SettingsRow>
      <SettingsRow
        title={t("order_form:color_settings.primary_color_dark.title")}
        description={t("order_form:color_settings.primary_color_dark.description")}
      >
        <div className="flex items-center gap-2">
          <input
            type="color"
            value={config.primaryColorDark || "#5B0ACD"}
            onChange={(e) => handleConfigChange("primaryColorDark", e.target.value)}
            className="w-8 h-8 rounded border border-border-strong cursor-pointer"
          />
          <input
            type="text"
            value={config.primaryColorDark || ""}
            onChange={(e) => handleConfigChange("primaryColorDark", e.target.value)}
            placeholder="#5B0ACD"
            className="w-24 px-2 py-1 text-sm border border-gray-300 rounded-md focus:border-brand focus:ring-1 focus:ring-brand dark:border-gray-600 dark:bg-gray-700 dark:text-white font-mono"
          />
        </div>
      </SettingsRow>
      <SettingsRow
        title={t("order_form:color_settings.header_color.title")}
        description={t("order_form:color_settings.header_color.description")}
        separator={false}
      >
        <div className="flex items-center gap-2">
          <input
            type="color"
            value={config.headerColor || "#FFFFFF"}
            onChange={(e) => handleConfigChange("headerColor", e.target.value)}
            className="w-8 h-8 rounded border border-border-strong cursor-pointer"
          />
          <input
            type="text"
            value={config.headerColor || ""}
            onChange={(e) => handleConfigChange("headerColor", e.target.value)}
            placeholder="#FFFFFF"
            className="w-24 px-2 py-1 text-sm border border-gray-300 rounded-md focus:border-brand focus:ring-1 focus:ring-brand dark:border-gray-600 dark:bg-gray-700 dark:text-white font-mono"
          />
        </div>
      </SettingsRow>
    </div>
  );
};

export default AppearanceTab;


